// eslint-disable-next-line import/prefer-default-export
import { PageWrapper } from './PageWrapper';
import { ensureBrandStylesheet } from './src/utils/brandStyles';

export const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    ensureBrandStylesheet(window.location.search);
  }
};

export const wrapPageElement = PageWrapper;
